import React, { useState, useEffect, useRef } from 'react';
import { Alert, Spinner } from 'react-bootstrap';
import { useAuth } from '../contexts/AuthContext';

const TelegramAuth = ({ onSuccess }) => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const { loginWithTelegram } = useAuth();
  const widgetContainerRef = useRef(null);

  const BOT_CONFIG = {
    username: 'IT_DNR_Bot',
  };

  useEffect(() => {
    initWidget();
  }, []);

  const initWidget = () => {
    if (widgetContainerRef.current) {
      widgetContainerRef.current.innerHTML = '';
      
      const script = document.createElement('script');
      script.src = 'https://telegram.org/js/telegram-widget.js?22';
      script.setAttribute('data-telegram-login', BOT_CONFIG.username);
      script.setAttribute('data-size', 'large');
      script.setAttribute('data-auth-url', `${window.location.origin}/_admin/telegram-callback.html`);
      script.setAttribute('data-request-access', 'write');
      script.setAttribute('data-radius', '8');
      script.setAttribute('data-userpic', 'true');
      script.async = true;

      widgetContainerRef.current.appendChild(script);
    }
  };

  useEffect(() => {
    const handleMessage = (event) => {
      if (event.origin !== window.location.origin) return;
      
      if (event.data && event.data.type === 'telegram_auth_data') {
        handleTelegramAuth(event.data.data);
      }
    };

    window.addEventListener('message', handleMessage);
    return () => window.removeEventListener('message', handleMessage);
  }, []);

  const handleTelegramAuth = async (telegramData) => {
    setLoading(true);
    setError('');
    
    console.log('📨 Telegram data received:', telegramData);
    
    try {
      const result = await loginWithTelegram(telegramData);
      
      if (result.success) {
        console.log('✅ Telegram auth successful');
        onSuccess && onSuccess();
      } else {
        console.error('❌ Telegram auth failed:', result.error);
        setError(result.error || 'Ошибка аутентификации');
      }
    } catch (err) {
      console.error('❌ Telegram auth error:', err);
      setError('Ошибка авторизации через Telegram. Пожалуйста, попробуйте еще раз.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="text-center">
      {error && (
        <Alert variant="danger" className="mb-3">
          {error}
        </Alert>
      )}

      <div ref={widgetContainerRef} className="mb-3">
        <div className="text-muted py-3">
          {loading ? 'Подключение к Telegram...' : 'Загрузка кнопки Telegram...'}
        </div>
      </div>

      {loading && (
        <div className="d-flex align-items-center justify-content-center gap-2 text-muted">
          <Spinner animation="border" size="sm" variant="primary" />
          Обработка авторизации...
        </div>
      )}
    </div>
  );
};

export default TelegramAuth;